<template>
    <div id="echart">
        <div class="line" :style="lineBgSty"></div>
        <div id="main1" v-if="main=='main1'"></div>
        <div id="main2" v-if="main=='main2'"></div>
        <div class="line" :style="lineBgSty"></div>
    </div>
    
</template>

<script>
// import echarts from 'echarts'
import * as echarts from 'echarts'
export default {
    props:{
        main:{
            type:[String],
        },
        timeEchartData:{
            type:[Object],
        },
        priceEchartData:{
            type:[Object],
        },
       
    },
    data(){
        return{
            option1 :{
                
            },
            option2 :{
                
            },
            lineBgSty:{},
            color:'',
            
            option1Data:{},
            option2Data:{},

          
        }
    },
    watch:{
        
        timeEchartData(o,n){
           this.option1Data=this.timeEchartData
           this.option1 ={
                    grid:{
                        height:'73%',
                        top:'15%',
                        bottom:'50%'
                    },
                    xAxis: {
                        type: 'category',
                        data: this.option1Data.xData,
                        axisTick:{
                            show:false // 不显示坐标轴刻度线
                        },
                        axisLine: {
                            show: false, // 不显示坐标轴线
                        },
                        axisLabel:{
                            interval:0
                            
                        }
                    },
                    yAxis: {
                        type: 'value',
                        splitLine:{
                            show:false
                        },
                        axisLabel: {
                            show: false, // 不显示坐标轴上的文字
                        },
                        
                    },
                    series: [
                        {
                            data: this.option1Data.yData,
                            type: 'bar',
                            barWidth:20,
                            barMaxWidth: 'auto',
                            showBackground: true,
                            label: {
                                show: true,
                                position: 'top',
                            },
                            backgroundStyle: {
                                color: 'rgba(94, 230, 255, 0.1)'
                            },
                            itemStyle:{
                                normal:{
                                    color:this.color,
                                    label:{
                                        show:true,
                                        position:'top',
                                        textStyle:{
                                            color:'rgba(255,255,255,0.8)',
                                        }
                                    }
                                }
                            },
                        
                        }
                    ]
            };
             var chartDom1 = document.getElementById('main1');
              if(chartDom1){
                var myChart1 = echarts.init(chartDom1);
                myChart1.setOption(this.option1);
            }
        },
        priceEchartData(o,n){
           this.option2Data=this.priceEchartData
           this.option2 ={
                    grid:{
                        height:'73%',
                        top:'15%',
                        bottom:'50%'
                    },
                    xAxis: {
                        type: 'category',
                        data: this.option2Data.xData,
                        axisTick:{
                            show:false // 不显示坐标轴刻度线
                        },
                        axisLine: {
                            show: false, // 不显示坐标轴线
                        },
                        axisLabel:{
                            interval:0
                            
                        }
                    },
                    yAxis: {
                        type: 'value',
                        splitLine:{
                            show:false
                        },
                        axisLabel: {
                            show: false, // 不显示坐标轴上的文字
                        },
                        
                    },
                    series: [
                        {
                            data: this.option2Data.yData,
                            type: 'bar',
                            barWidth:20,
                            barMaxWidth: 'auto',
                            showBackground: true,
                            label: {
                                show: true,
                                position: 'top',
                            },
                            backgroundStyle: {
                                color: 'rgba(94, 230, 255, 0.1)'
                            },
                            itemStyle:{
                                normal:{
                                  
                                    color:this.color,
                                    label:{
                                        show:true,
                                        position:'top',
                                        textStyle:{
                                            color:'rgba(255,255,255,0.8)',
                                        }
                                    }
                                }
                                
                                
                            },
                        
                        }
                    ]
            };
            var chartDom2 = document.getElementById('main2');
           
            if(chartDom2){
                var myChart2 = echarts.init(chartDom2);
                myChart2.setOption(this.option2);
            }  
        },
    },
    mounted(){
        let that=this;
       
            if(that.$route.query.type=='steam'){
                that.lineBgSty={
                    background:'#5EE6FF'
                }
                that.color=new echarts.graphic.LinearGradient(0,1,0,0,[{
                    offset:0,
                    color:'#5EFFFD'
                },{
                    offset:1,
                    color:'#5ED3FF'
                }])
            }else if(that.$route.query.type=='psn'){
                that.lineBgSty={
                    background:'#5EA6FF'
                }
                that.color=new echarts.graphic.LinearGradient(0,1,0,0,[{
                    offset:0,
                    color:'#5EC8FF'
                },{
                    offset:1,
                    color:'#5E9BFF'
                }])
            }else if(that.$route.query.type=='xbox'){
                that.lineBgSty={
                    background:'#5EFF97'
                }
                
                that.color=new echarts.graphic.LinearGradient(0,1,0,0,[{
                    offset:0,
                    color:'#5EFFC8'
                },{
                    offset:1,
                    color:'#5EFF9E'
                }])
            }else if(that.$route.query.type=='epic'){
                that.lineBgSty={
                    background:'#FF5E5E'
                }
                that.color=new echarts.graphic.LinearGradient(0,1,0,0,[{
                    offset:0,
                    color:'#FF4D4D'
                },{
                    offset:1,
                    color:'#FF5D3D'
                }])
            }
           
           
       
     
       

    },
   
}
</script>

<style>

#main1{
    width: 100%;
    height: 9.5rem;
    display: flex;
    align-items: center;
}
#main1>div{
    height: 100% !important;
}
#main2{
    width: 100%;
    height: 9.5rem;
}
#main2>div{
    height: 100% !important;
}
#echart .line{
    height: 0.05rem;
    background: #5EE6FF;
    margin: 0 1.4rem;
}
</style>